import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'wo-details-wrapper',
  template: '<div class="wo-details-wrapper"><ng-content/></div>',
  styles: [ `
    :host {
      display: block;

      .wo-details-wrapper {
        border-radius: 4px;
        padding: 12px;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &::before {
          height: 100%;
          width: 4px;
          position: absolute;
          content: '';
          left: 0;
          top: 0;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
      }

      &:not(.wo-details-wrapper-transparent) .wo-details-wrapper {
        background: #F2F7FF;
      }

      &.wo-details-wrapper-critical .wo-details-wrapper:before {
        background: #ce455c;
      }

      &.wo-details-wrapper-warning .wo-details-wrapper:before {
        background: #fde2a3;
      }
    }
  ` ],
  standalone: true,
})
export class DetailsWrapperComponent {
  @HostBinding('class.wo-details-wrapper-transparent')
  @Input() public transparent?: boolean;

  @HostBinding('class.wo-details-wrapper-critical')
  @Input() public critical?: boolean;

  @HostBinding('class.wo-details-wrapper-warning')
  @Input() public warning?: boolean;
}
